import { demoSiteOrigin } from "./demoSiteOrigin";

export function redirectToDemoSite() {
  const destinationUrl = new URL(demoSiteOrigin);
  destinationUrl.search = location.search;
  location.href = destinationUrl.toString()
}
